export default __webpack_public_path__ + "static/media/USDT.84be4d1c.svg";